import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da1b9ulrlbpoffc5h3cg";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [honey, setHoney] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubscribe(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (honey.trim()) {
      setStatus("success");
      setMessage("订阅成功，感谢你的关注！");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setMessage("请输入有效的邮箱地址。");
      return;
    }
    setStatus("loading");
    try {
      const formData = new FormData(e.currentTarget);
      if (honey.trim()) formData.delete("phone_alt");
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.meta?.detail ||
        (parsed as { message?: string } | null)?.message ||
        "";
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage("订阅成功，新番推荐马上送达！");
        setEmail("");
      } else {
        setStatus("error");
        setMessage(
          serverMsg && /spam/i.test(serverMsg)
            ? "提交失败，请稍后再试。"
            : serverMsg || "订阅失败，请稍后重试。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  }

  return (
    <footer id="contact" className="bg-background-100 py-12 md:py-16 border-t border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 text-lg">
                <i className="ri-footprint-line"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">小狗看番</span>
            </div>
            <p className="mt-4 max-w-md text-sm text-foreground-600 leading-relaxed">
              专注狗狗主角、动物拟人、兽耳萌系与宠物日常动画的垂直内容站。为萌宠控精挑细选每一部合口味的番，让毛茸茸的快乐被更多人看见。
            </p>
            <div className="mt-5 flex items-center gap-3 text-sm text-foreground-600">
              <a href="mailto:hello@xiaogoukanfan.cn" className="inline-flex items-center gap-1.5 hover:text-primary-700 transition-colors">
                <i className="ri-mail-line"></i>
                hello@xiaogoukanfan.cn
              </a>
            </div>
            <div className="mt-4 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-douban-line"].map((i) => (
                <a
                  key={i}
                  href="#contact"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors"
                >
                  <i className={`${i} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950">快捷导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {[
                ["热门推荐", "#hot"],
                ["番剧分类", "#category"],
                ["人气排行", "#rank"],
                ["新番速递", "#new"],
                ["常见问题", "#faq"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="hover:text-primary-700 transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-950">订阅更新</h4>
            <p className="mt-4 text-sm text-foreground-600">
              每周精选萌宠番推荐，第一时间送达你的邮箱。
            </p>
            <form
              data-readdy-form="true"
              onSubmit={handleSubscribe}
              className="mt-4"
            >
              <div className="flex flex-col gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入你的邮箱"
                  autoComplete="off"
                  className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
                />
                <input
                  type="text"
                  name="phone_alt"
                  value={honey}
                  onChange={(e) => setHoney(e.target.value)}
                  tabIndex={-1}
                  aria-hidden="true"
                  readOnly
                  autoComplete="off"
                  className="spam-guard"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer"
                >
                  {status === "loading" ? "提交中…" : "立即订阅"}
                  <i className="ri-send-plane-line text-sm"></i>
                </button>
              </div>
              {message && (
                <p
                  className={`mt-3 text-xs ${
                    status === "success" ? "text-secondary-700" : "text-accent-700"
                  }`}
                >
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/80 pt-6 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 小狗看番 Xiaogou Kanfan. 用心推荐每一部毛茸茸的好番。</p>
          <p className="inline-flex items-center gap-1">
            <i className="ri-heart-3-fill text-accent-500"></i>
            与萌宠控同行
          </p>
        </div>
      </div>
    </footer>
  );
}